import type { SipDeviceCredentialDto } from './dtos/agent-management/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SipCredentialService {
  apiName = 'Default';
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SipDeviceCredentialDto>({
      method: 'GET',
      url: `/api/agentic-cx/sip-credential/${id}`,
    },
    { apiName: this.apiName,...config });
  

  rotate = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SipDeviceCredentialDto>({
      method: 'POST',
      url: `/api/agentic-cx/sip-credential/${id}/rotate`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
